import Insight from "../insightClass";
import React from "react";
import { insight110Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight110 = new Insight(
  "04 May 2026",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight110Media[0],
    alt: "offshore wind farm",
  },
  "Global Offshore Wind Weekly (2026-05-04)",
  "",
  `Cadeler has mobilised Wind Ally and Wind Orca for foundation transport and installation at Hornsea 3. Wind Ally has arrived at Teesworks following mobilisation in Rotterdam, with monopile loading under way. Wind Orca has completed maintenance and mobilisation across multiple ports including Esbjerg, Odense and Tyne.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2026-05-04)</h1>
    <h2></h2>
    <p className="article-date">04 May 2026</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>

    <h3>1. Hornsea 3 moves into foundation installation phase</h3>
    <p>
      Cadeler has mobilised Wind Ally and Wind Orca for foundation transport and
      installation at Hornsea 3. Wind Ally has arrived at Teesworks following
      mobilisation in Rotterdam, with monopile loading under way. Wind Orca has
      completed maintenance and mobilisation across multiple ports including
      Esbjerg, Odense and Tyne.
    </p>
    <p>
      Hornsea 3, developed by Ørsted, will feature 197 Siemens Gamesa 14 MW
      turbines with a total capacity of 2.9 GW. It is expected to be fully
      operational in 2027 and supply electricity to more than 3.3 million UK
      homes.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This marks a critical execution milestone for the UK offshore wind
      pipeline. Hornsea 3 is not only one of the largest projects globally but
      also a real-time test of whether large-scale delivery remains feasible
      under today’s supply chain and cost conditions.The role of installation
      vessels is becoming increasingly strategic. Access to next-generation
      heavy-lift vessels is now a key bottleneck in project delivery timelines.
      Developers that secure vessel capacity early are better positioned to
      mitigate schedule risks.
    </p>
    <p>
      For the broader market, Hornsea 3 reinforces that scale remains
      achievable—but only with tighter coordination across engineering,
      logistics and supply chain planning. It also sets a benchmark for future
      UK projects navigating similar constraints.
    </p>
    <h3>2. RWE signs 15-year PPA linked to Gwynt y Môr</h3>
    <p>
      RWE has signed a 15-year power purchase agreement with Breedon Group to
      supply around 70 GWh of electricity annually until 2041. The electricity
      will initially be sourced from the 576 MW Gwynt y Môr offshore wind farm
      off North Wales, transitioning to onshore wind from 2033.
    </p>
    <p>
      The agreement supports Breedon’s decarbonisation strategy across
      energy-intensive building materials operations including cement and
      asphalt production.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This agreement highlights the evolving commercial role of operational
      offshore wind assets. Mature wind farms are increasingly being integrated
      into long-term corporate procurement strategies rather than relying solely
      on wholesale markets.
    </p>
    <p>
      The industrial buyer profile is particularly significant. Heavy industry
      is under growing pressure to decarbonise, and offshore wind is becoming a
      viable route to secure long-term renewable power supply at scale.
    </p>
    <p>
      For developers and asset owners, this expands revenue visibility and
      supports refinancing strategies. It also signals a broader shift: offshore
      wind is moving beyond power generation into a core component of industrial
      decarbonisation infrastructure.
    </p>
    <h3>3. UK offshore wind-linked long-duration storage project advances</h3>
    <p>
      EnergyPathways has launched FEED work for a compressed air energy storage
      (CAES) project in the East Irish Sea. The project, part of the MESH
      development, is designed to store excess electricity from offshore wind
      farms.
    </p>
    <p>
      The facility is planned with 300 MW of power capacity and 55.2 GWh of
      storage, capable of delivering over seven days of discharge. Final
      investment decision is targeted for 2028, with operations expected by
      2031.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This project reflects a structural shift in offshore wind development—from
      generation expansion to system integration. As capacity grows, grid
      constraints and curtailment risks become more prominent.
    </p>
    <p>
      Long-duration storage offers a solution by converting intermittent
      offshore wind into dispatchable energy. This improves system stability
      while enhancing the economic value of renewable generation.
    </p>
    <p>
      The UK’s offshore geology and existing energy infrastructure create a
      strong foundation for integrating storage, hydrogen and offshore wind. If
      successfully delivered, projects like this could redefine how offshore
      wind assets interact with the wider energy system.
    </p>
    <h3>
      4. France’s Îles d’Yeu and Noirmoutier project reaches full operation
    </h3>
    <p>
      The 488 MW Îles d’Yeu and Noirmoutier offshore wind farm has completed
      turbine installation and entered full operation. The project includes 61
      Siemens Gamesa 8 MW turbines and is located off the French Atlantic coast.
    </p>
    <p>
      It is expected to generate electricity equivalent to the annual
      consumption of nearly 800,000 people and supported approximately 2,400
      jobs during construction.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      France’s offshore wind sector has historically lagged behind its European
      peers, but this project signals a transition into consistent delivery.
    </p>
    <p>
      Local content and job creation remain central to the French model,
      reinforcing political support for future projects. For developers, each
      successfully delivered project reduces perceived execution risk and
      strengthens investor confidence.
    </p>
    <p>
      At a European level, the expansion of operational capacity in France
      contributes to overall market maturity and diversification beyond
      traditional strongholds such as the UK and Germany.
    </p>
    <h3>
      5. Netherlands advances feed-in tariff for offshore wind and large
      generators
    </h3>
    <p>
      The Netherlands is moving towards introducing a feed-in tariff for large
      electricity producers, including offshore wind farms. The proposal, led by
      the Dutch regulator ACM, aims to address rising grid congestion and
      infrastructure costs.
    </p>
    <p>
      Under the plan, large generators would contribute to grid costs, which are
      currently largely borne by consumers. The measure is intended to
      incentivise more efficient use of grid capacity and reduce the need for
      large-scale network expansion.
    </p>
    <p>
      The tariff would be introduced gradually, with implementation not expected
      before 2032. The approach aligns with similar mechanisms already in place
      in countries such as Belgium, Denmark and the UK.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This represents a notable policy shift in how offshore wind interacts with
      electricity systems. Historically, grid costs have been socialised, but
      increasing renewable penetration is forcing regulators to reconsider cost
      allocation.
    </p>
    <p>
      Introducing feed-in tariffs for generators signals a move towards more
      system-aware market design. Offshore wind developers may need to adapt
      operational strategies, including curtailment management, hybridisation
      with storage, or co-location with flexible demand.
    </p>
    <p>
      For investors, this adds a new layer of complexity to revenue modelling.
      While it may increase costs, it also encourages more efficient system
      integration, which is essential as Europe moves towards higher renewable
      penetration.
    </p>
    <h3>6. US agrees offshore wind lease cancellations</h3>
    <p>
      The US government has agreed to terminate two offshore wind leases,
      covering Bluepoint Wind and Golden State Wind projects, with lease
      payments refunded under certain conditions.The projects represented 2.4 GW
      and 2 GW of planned capacity respectively and were located off the coasts
      of New York and California.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This decision underscores the increasing political risk in the US offshore
      wind sector. While these were early-stage projects, policy direction plays
      a critical role in shaping investment confidence.
    </p>
    <p>
      The cancellation of leases introduces uncertainty for developers,
      particularly around long-term regulatory stability. This could slow supply
      chain investment and delay project pipelines.
    </p>
    <p>
      Compared to Europe’s acceleration strategy, the divergence in policy
      direction is becoming more pronounced. Developers may increasingly
      prioritise markets with clearer long-term policy support.
    </p>
    <h3>7. China installs 16 MW floating offshore wind unit</h3>
    <p>
      China has begun installing a 16 MW floating offshore wind turbine in deep
      waters off Yangjiang. The unit is among the largest of its kind globally
      and represents a significant step in floating wind deployment.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Floating offshore wind is widely seen as the next frontier for the
      industry, and China’s rapid scaling efforts are notable. The move towards
      larger turbine ratings is critical for improving project economics.
    </p>
    <p>
      Larger units reduce the number of foundations, moorings and electrical
      connections required, lowering overall system costs. China’s strength in
      manufacturing and rapid deployment could accelerate cost reductions
      globally.
    </p>
    <p>
      For Europe, which has led early floating wind development, this signals
      increasing competition in the industrialisation phase. The next stage will
      be defined not by pilot projects, but by scalable, cost-efficient
      deployment.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
